

import { useOnboarding } from "@/hooks/use-onboarding";
import {
  IonButton,
  IonContent,
  IonFooter,
  IonPage,
  IonToolbar
} from "@ionic/react";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import GolfHandicapInput from "../GolfHandicapInput";

const HandicapSelection: React.FC<{ nextStep: string; }> = ({ nextStep }) => {
  const history = useHistory();
  const { updateOnboardingData, completeStep, onboardingData } = useOnboarding();
  const { t } = useTranslation();

  const [handicap, setHandicap] = useState(54.0);

  useEffect(() => {
    if (onboardingData.handicap) {
      setHandicap(onboardingData.handicap);
    }
  }, [onboardingData]);

  const handleSubmit = async () => {
    await updateOnboardingData({ handicap });
    await completeStep("handicap");
    history.push(nextStep);
  };

  return (
    <IonPage>
      <IonContent>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-center justify-center bg-card h-full"
        >
          <h1 className="text-3xl font-semibold mb-6">{t("my_index")}:</h1>

          <GolfHandicapInput size="lg" fill="outline" initialValue={handicap} onChange={setHandicap} />
          <IonButton
            shape="round"
            expand="block"
            className="mt-8 hidden md:block"
            onClick={handleSubmit}
          >
            {t("next")}
          </IonButton>
        </motion.div>
      </IonContent>
      <IonFooter className="ion-no-border bg-card md:hidden">
        <IonToolbar>
          <IonButton
            shape="round"
            expand="block"
            className="m-4"
            onClick={handleSubmit}
          >
            {t("next")}
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default HandicapSelection;